import { CountryType } from '../countries/types';
import { DistrictType } from '../districts/types';

type Photo = {
  assetPath: string;
  id: number;
  name: string;
  smallAssetPath: string;
};

type Text = {
  language: string;
  text: string | null;
  textKey: string;
};

type GolfhaftetRating = {
  name: string;
  rating: number;
  user_ratings_total: number;
  reviews: unknown;
  dateRun: string;
};

type GoogleRating = {
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
    viewport: {
      northeast: {
        lat: number;
        lng: number;
      };
      southwest: {
        lat: number;
        lng: number;
      };
    };
  };
  name: string;
  rating: number;
  user_ratings_total: number;
  reviews: unknown;
  dateRun: string;
};

type LinkType = { link: string };

export type GolfCourseType = {
  id: number;
  name: string;
  numberOfHoles: number;
  information: string | null;
  golfhaftetId: number | string | null;
  hasTee10Start?: boolean;
};

export enum GolfClubPromotion {
  NoPromotion = 0,
  Promoted = 1,
  Recommended = 2,
}

export type GolfClubType = {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  golfCourses: GolfCourseType[];
  country: CountryType;
  district: DistrictType;
  information: string | null;
  promotion: GolfClubPromotion | null;
  address: string | null;
};

export type GolfClubInfoType = {
  accommodationId: number | null;
  golfClubId: number;
  golfhaftetRating: GolfhaftetRating | null;
  googleRating: GoogleRating | null;
  hasAccommodation: boolean;
  photos: Photo[];
  texts: Text[];
  campingMapUrl: string | null;
  accommodationInfo: string | null;
  accommodationInfoSv: string | null;
  address: string | null;
  promotion: GolfClubPromotion | null;
};

export type MappedGolfClubInfoType = Pick<
  GolfClubInfoType,
  | 'accommodationId'
  | 'hasAccommodation'
  | 'golfhaftetRating'
  | 'googleRating'
  | 'photos'
  | 'campingMapUrl'
  | 'address'
> & {
  description?: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
  h1?: string | null;
  h2?: string | null;
  h3?: string | null;
  image: string;
};

export type MappedGolfCourseType = {
  id: string;
  golfCourse: Pick<GolfCourseType, 'name' | 'id' | 'numberOfHoles' | 'golfhaftetId'> & LinkType;
  name: string;
  search: string;
  golfClub: Pick<GolfClubType, 'name' | 'id'> & LinkType;
  info: MappedGolfClubInfoType | unknown;
  // todo used here: src/pages/booking/index.tsx
  distance: number | null;
} & Pick<
  GolfClubType,
  'country' | 'district' | 'information' | 'latitude' | 'longitude' | 'golfCourses' | 'promotion'
>;

export type ActiveGolfClubsResponseType = GolfClubType[];

export type GolfClubsInfoResponseType = GolfClubInfoType[];
